import React, { useState, useEffect, useRef } from 'react';
import { useApp } from '../context/AppContext';
import { playNotificationSound } from '../utils/notificationSound';
import styled, { keyframes } from 'styled-components';

const slideInRight = keyframes`
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

const Item = styled.div`
  background: #28a745;
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: ${slideInRight} 0.3s ease-out;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  transition: box-shadow 0.2s;
  border: 1px solid rgba(255,255,255,0.2);

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }
`;

const Body = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 1.4;
`;

const Title = styled.div`
  font-weight: 700;
  margin-bottom: 4px;
`;

const Text = styled.div`
  opacity: 0.95;
  font-size: 13px;
`;

const CloseBtn = styled.button`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: 2px solid rgba(255,255,255,0.8);
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  color: #fff;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background 0.2s;

  &:hover {
    background: rgba(255,255,255,0.35);
  }
`;

function formatHours(minutes) {
  if (minutes == null) return '—';
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  if (m === 0) return `${h} ч`;
  return `${h} ч ${m} мин`;
}

export default function EmployeeWorktimeCompletedNotification() {
  const { state } = useApp();
  const [notification, setNotification] = useState(null);
  const playedRef = useRef(false);

  const isEmployee = state.user && !['hr', 'admin', 'руководитель'].includes((state.user.role || '').toLowerCase());

  useEffect(() => {
    if (!isEmployee) return;
    const handler = (e) => {
      const detail = e.detail || {};
      setNotification({
        id: `emp-${Date.now()}`,
        totalWorkedMinutes: detail.totalWorkedMinutes,
        requiredMinutes: detail.requiredMinutes,
        username: detail.username
      });
      if (!playedRef.current) {
        playedRef.current = true;
        playNotificationSound();
      }
      setTimeout(() => { playedRef.current = false; }, 2000);
    };
    window.addEventListener('worktime-completed-employee', handler);
    return () => window.removeEventListener('worktime-completed-employee', handler);
  }, [isEmployee]);

  const handleDismiss = () => setNotification(null);

  if (!isEmployee || !notification) return null;

  return (
    <Item>
      <Body>
        <Title>✅ Отработка завершена</Title>
        <Text>
          Отработано: {formatHours(notification.totalWorkedMinutes)} из {formatHours(notification.requiredMinutes)}. Статус: на проверке у HR.
        </Text>
      </Body>
      <CloseBtn type="button" onClick={handleDismiss} aria-label="Закрыть" title="Закрыть">×</CloseBtn>
    </Item>
  );
}
